import { SettingsService } from '../../../../../services/settings-service';
import UserCentricViewController from '../../../usercentrics-view-controller';
import { debounce } from 'ts-debounce';
import { DataService } from '../../../../../services/utilities/data.service';
import { Consent } from '../../../../../dataTypes/type-consent';
import { GetConsentsService } from '../../../../../services/consents-services/get-consents.service';
import { ConsentsToggleService } from '../../../../../services/consents-services/consents-toggle-detail.service';
import { ConsentsStatusService } from '../../../../../services/consents-services/consents-status.service';

const _ = require('lodash');
const stateName = 'secondaryAdvancePrivacyView';
const selectAllItemClassName = 'uc-select-all-items';

const cornerModalSecondaryAdvanceSettingsTemplate1
    = require('./templates/privacy-corner-modal-settings-templates/corner-settings-template-1.hbs');
const cornerModalSecondaryAdvanceSettingsTemplate5
    = require('./templates/privacy-corner-modal-settings-templates/corner-settings-template-5.hbs');
const cornerModalSecondaryAdvanceSettingsTemplate8
    = require('./templates/privacy-corner-modal-settings-templates/corner-settings-template-8.hbs');
const cornerModalSecondaryAdvanceSettingsTemplate11
    = require('./templates/privacy-corner-modal-settings-templates/corner-settings-template-11.hbs');
const cornerModalSecondaryAdvanceSettingsTemplate12
    = require('./templates/privacy-corner-modal-settings-templates/corner-settings-template-12.hbs');
export default class SecondaryAdvanceSettingsViewController {
    static CONTROLLER_NAME = 'secondaryAdvanceSettingsViewController';
    private modalScope: any;
    private layoutParams: any;
    private settingsService: SettingsService;
    private utilityService: any;
    private secondaryAdvanceViewController: any;

    private scrollPos = 0;
    private isVisible: boolean;
    copiedText = '';

    constructor(
        modalScope,
        layoutParams,
        utilityService,
        secondaryAdvanceViewController
    ) {
        this.secondaryAdvanceViewController = secondaryAdvanceViewController;
        this.utilityService = utilityService;
        this.isVisible = true;
        this.layoutParams = layoutParams;
        this.modalScope = modalScope;

        this.settingsService = utilityService.settingsService;
        this.initializeToggleFields();
    }

    private consentCopyFields: { string?: Consent.ConsentCopyFields } = {};
    private consentToggleFields: { string?: Consent.ConsentToggleFields } = {};
    private categoryToggleFields = {};

    private setState() {
        this.modalScope.changeState(stateName);
    }

    private getViewHTML() {
        switch (this.layoutParams.modalView) {
            case 'center-modal-template-5':
            case 'corner-modal-template-5':
                return cornerModalSecondaryAdvanceSettingsTemplate5;
            case 'center-modal-template-8':
            case 'corner-modal-template-8':
                return cornerModalSecondaryAdvanceSettingsTemplate8;
            case 'center-modal-template-11':
            case 'corner-modal-template-11':
                return cornerModalSecondaryAdvanceSettingsTemplate11;
            case 'center-modal-template-12':
            case 'corner-modal-template-12':
                return cornerModalSecondaryAdvanceSettingsTemplate12;
            case 'center-modal-template-1':
            case 'corner-modal-template-1':
            default:
                return cornerModalSecondaryAdvanceSettingsTemplate1;
        }
    }

    updateCopiedTextForConsent(consent) {
        if (this.copiedText === GetConsentsService.getConsentId(consent)) {
            this.consentCopyFields[consent.templateId].copiedConsentId = true;
        } else {
            this.consentCopyFields[consent.templateId].copiedConsentId = false;
        }
        if (this.copiedText === consent.controllerId) {
            this.consentCopyFields[consent.templateId].copiedControllerId = true;
        } else {
            this.consentCopyFields[consent.templateId].copiedControllerId = false;
        }
        if (this.copiedText === consent.processorId) {
            this.consentCopyFields[consent.templateId].copiedProcessorId = true;
        } else {
            this.consentCopyFields[consent.templateId].copiedProcessorId = false;
        }
    }

    private getHtml() {
        this.utilityService.developmentLog('getting setting view');
        const viewHTML: any = this.getViewHTML();
        const optInConsent = GetConsentsService.getOptinConsent();

        this.consentCopyFields[optInConsent.templateId] = {
            copiedConsentId: false,
            copiedControllerId: false,
            copiedProcessorId: false
        };
        
        this.updateCopiedTextForConsent(optInConsent);
        DataService.categories.forEach((category, catIndex) => {
            category.consents.forEach(consent => {
                this.consentCopyFields[consent.templateId] = {
                    copiedConsentId: false,
                    copiedControllerId: false,
                    copiedProcessorId: false
                };
                this.updateCopiedTextForConsent(consent);
            });
        });
        const viewData = {
            allDisabled: !this.utilityService.isConsentChangeAllow,
            settings: this.settingsService.settings,
            consents: DataService.consents,
            categories: DataService.categories,
            consentCopyFields: this.consentCopyFields,
            consentToggleFields: this.consentToggleFields,
            categoryToggleFields: this.categoryToggleFields,
            consentTemplates: DataService.consentTemplates,
            allStatuses: ConsentsStatusService.selectAllStatus.status,
            allStatusesIntermediate: ConsentsStatusService.selectAllStatus.isIntermediateState,
            showHideBanner: this.settingsService.elementsVisibility.bannerVisible,
            optInConsent: optInConsent,
            icons: UserCentricViewController.icons,
        };
        this.utilityService.developmentLog('got setting view');
        return viewHTML(viewData);
    }

    public initHandling() {
        this.utilityService.developmentLog('initializing setting view');
        const self = this;

        if (self.isVisible) {
            const modalWrapperElement = self.modalScope.getModalWrapperElement();
            const optIn = GetConsentsService.getOptinConsent();
            if (optIn) {
                const optInElement = modalWrapperElement.querySelector(
                    '#open-close-description-' + optIn.templateId
                );
                const toggleOPtinElements = modalWrapperElement.getElementsByClassName(
                    'toggle-consent-' + optIn.templateId
                );
                if (toggleOPtinElements) {
                    _.forEach(toggleOPtinElements, toggleElm => {
                        if (toggleElm) {
                            toggleElm.onclick = (event: any) => {
                                event.preventDefault();
                                event.stopPropagation();
                                const checkboxForConsentToggling = modalWrapperElement.getElementsByClassName(
                                    'checkbox-toggle-consent-' + optIn.templateId
                                );
                                _.forEach(checkboxForConsentToggling, checkboxElm => {
                                    checkboxElm.checked = !checkboxElm.checked;
                                });
                                self.updateSelectedStatusForConsent(optIn);
                            };
                        }
                    });
                }
                if (optInElement) {
                    optInElement.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        self.showHideDescriptionForConsent(this.consentToggleFields[optIn.templateId]);
                    };
                }
            }

            _.forEach(DataService.categories, (category: any) => {
                const categoryId = category.categorySlug;

                const categoryElement = modalWrapperElement.querySelector(
                    '#uc-category-click-' + categoryId
                );
                const toggleCategoryElements = modalWrapperElement.getElementsByClassName(
                    'toggle-category-' + categoryId
                );

                if (categoryElement) {
                    categoryElement.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        self.showHideDescriptionForCategory(category);
                    };
                }

                _.forEach(toggleCategoryElements, toggleElm => {
                    if (toggleElm) {
                        toggleElm.onclick = (event: any) => {
							/**
							 * We stop propgation to prevent category open/close
							 * and using for of label, we change the value of input type checkbox so we can listen to checkbox 'change'
							 */
                            event.stopPropagation();
                            self.utilityService.developmentLog('category is clicked');
                        };
                        toggleElm.addEventListener('change', function (event: any) {
                            self.utilityService.developmentLog(
                                'onchange called',
                                event.target.checked
                            );
                            
                            event.preventDefault();

                            ConsentsStatusService.changeCategorySelectedStatus(category, event.target.checked);
                            self.updateWholeModalView();
                        });
                    }
                });
            });

            _.forEach(DataService.consents, (consent: any) => {
                const consentId = consent.templateId;
                const consentElement = modalWrapperElement.querySelector(
                    '#uc-consent-details-id-' + consentId
                );
                const mobileConsentElement = modalWrapperElement.querySelector(
                    '#mobile-uc-consent-details-id-' + consentId
                );
                if (consentElement) {
                    if (mobileConsentElement) {
                        mobileConsentElement.onclick = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            consentElement.click();
                        };
                    }
                    consentElement.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        self.showHideDescriptionForConsent(this.consentToggleFields[consent.templateId]);
                    };
                }
                const toggleConsentElements = modalWrapperElement.getElementsByClassName(
                    'toggle-consent-' + consentId
                );
                const copyElements = modalWrapperElement.getElementsByClassName(
                    'consent-copy-' + consentId
                );

                _.forEach(copyElements, copyElement => {
                    if (copyElement) {
                        copyElement.onclick = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            if (copyElement.getAttribute('data-type') === 'consentId') {
                                self.copyText(GetConsentsService.getConsentId(consent));
                            } else {
                                self.copyText(consent[copyElement.getAttribute('data-type')]);
                            }
                        };
                    }
                });

                const showHistoryElement = modalWrapperElement.querySelector(
                    '#uc-consent-history-id-' + consentId
                );
                const mobileShowHistoryElement = modalWrapperElement.querySelector(
                    '#mobile-uc-consent-history-id-' + consentId
                );
                if (showHistoryElement) {
                    if (mobileShowHistoryElement) {
                        mobileShowHistoryElement.onclick = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            showHistoryElement.click();
                        };
                    }
                    showHistoryElement.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        self.showHideHistoryForConsent(this.consentToggleFields[consent.templateId]);
                    };
                }

                const showSubConsentsElements = modalWrapperElement.querySelectorAll(
                    '.uc-sub-consent-id-' + consentId
                );
                if (showSubConsentsElements) {
                    _.forEach(showSubConsentsElements, showSubConsentElement => {
                        if (showSubConsentElement) {
                            showSubConsentElement.onclick = (event: any) => {
                                event.preventDefault();
                                event.stopPropagation();
                                self.showHideSubConsentsForConsent(this.consentToggleFields[consent.templateId]);
                            };
                        }
                    });
                }

                _.forEach(toggleConsentElements, toggleElm => {
                    if (toggleElm) {
                        toggleElm.onclick = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            self.utilityService.developmentLog('consent checkbox is clicked', consentId);
                            self.updateSelectedStatusForConsent(consent);
                        };
                    }
                });
            });

            const selectAllItemElement = modalWrapperElement.getElementsByClassName(
                selectAllItemClassName
            );
            _.forEach(selectAllItemElement, elem => {
                if (elem) {
                    elem.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        self.updateSelectedStatusForAllCategories(!ConsentsStatusService.selectAllStatus.status);
                    };
                }
            });

            this.getScrollPosition();
        }
    }

    private setScrollPosition() {
        const scrollDiv = document.getElementById('myTabContent');
        this.scrollPos = scrollDiv.scrollTop;
    }

    private getScrollPosition() {
        const scrollDiv = document.getElementById('myTabContent');
        scrollDiv.scrollTop = this.scrollPos;
    }

    private updateWholeModalView() {
        this.setScrollPosition();
        this.secondaryAdvanceViewController.updateView();
    }

    private updateSettingView() {
        this.updateWholeModalView();
    }

    copyText(string) {
        const el = document.createElement('textarea');
        el.value = string;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        try {
            document.execCommand('copy');
            document.body.removeChild(el);
            this.copiedText = string;
            this.updateSettingView();
        } catch (err) {
            console.log(err);
            document.body.removeChild(el);
        }
    }

    initializeToggleFields() {
        DataService.consents.forEach(consent => {
            this.consentToggleFields[consent.templateId] = {
                showDetail: false,
                showSubConsents: false,
                showHistory: false
            };
        });
        DataService.categories.forEach(category => {
            this.categoryToggleFields[category.categorySlug] = false;
        });
    }

    public showHideDescriptionForConsent(consentToggleFields) {
        ConsentsToggleService.changeConsentShowDetailStatus(consentToggleFields, !consentToggleFields.showDetail);
        this.updateSettingView();
    }

    public showHideHistoryForConsent(consentToggleFields) {
        ConsentsToggleService.changeConsentShowHistoryStatus(consentToggleFields, !consentToggleFields.showHistory);
        this.updateSettingView();
    }

    public showHideSubConsentsForConsent(consentToggleFields) {
        ConsentsToggleService.changeConsentShowSubConsentStatus(consentToggleFields, !consentToggleFields.showSubConsents);
        this.updateSettingView();
    }

    public showHideDescriptionForCategory(category) {
        this.categoryToggleFields[category.categorySlug] = !this.categoryToggleFields[category.categorySlug];
        this.updateSettingView();
    }

    public updateSelectedStatusForConsent(consent) {
        ConsentsStatusService.setUnsavedConsentStatus(consent, !consent.unsavedConsentStatus);
        this.updateWholeModalView();
    }

    public updateSelectedStatusForAllCategories = debounce(
        function (status?) {
            DataService.consents.forEach((consent) => {
                ConsentsStatusService.setUnsavedConsentStatus(consent, status);
            });
            this.updateWholeModalView();
        },
        50,
        { isImmediate: false }
    );

    public static updateSelectedNotsaved(status?) {
        DataService.consents.forEach((consent) => {
            ConsentsStatusService.setUnsavedConsentStatus(consent, status);
        });
    }

    public set visible(_visible) {
        this.isVisible = _visible;
    }

    public get visible() {
        return this.isVisible;
    }

    public get htmlString(): string {
        if (this.isVisible) {
            return this.getHtml();
        }
        return '';
    }
}
